import { FC, useMemo } from 'react'
import styles from 'components/features/socialFeed/SocialInsightGroupsList/SocialInsightGroupsList.styl'
import { SocialInsightGroup } from 'components/features/socialFeed/SocialInsightGroup/SocialInsightGroup'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { createOpportunitiesCategoriesSelector } from 'selectors/oppertunitiesSelectors'
import { WithPlacement } from 'interfaces/insights'
import { OpportunityPlacement } from 'interfaces/opportunities'
import { createFakeInsight } from 'helpers/insightHelpers'
import { SocialInnerInsight } from 'interfaces/socialInsights'
import { NO_OPPORTUNITIES_TEXT, OPPORTUNITIES_PAGE_PLACEMENT } from 'constants/opportunities'
import { SocialInsightCard } from 'components/features/socialFeed/SocialInsightCard/SocialInsightCard'
import Insight from 'components/features/insights/Insight/Insight'

type SocialInsightGroupsListProps =
  & WithPlacement<OpportunityPlacement>
  & {

  }

export const SocialInsightGroupsList: FC<SocialInsightGroupsListProps> = (props) => {
  const { placement } = props
  const categoriesSelector = useMemo(() => createOpportunitiesCategoriesSelector(placement), [placement])
  const categories = useStoreSelector((state) => categoriesSelector(state, props))

  const children = useMemo(() => {
    const result = categories.map((category, index) => {
      if (category.isPreset) {
        return null
      }
      return (
        <div className={ styles.group } key={ index }>
          <SocialInsightGroup categoryId={ category.id } placement={ placement } />
        </div>
      )
    }).filter(Boolean)

    if (result.length === 0) {
      const zeroStateInsight = createFakeInsight<SocialInnerInsight>({
        placement: OPPORTUNITIES_PAGE_PLACEMENT,
        type: 'zero_state',
        tags: [],
        is_dismissed: true,
        text: NO_OPPORTUNITIES_TEXT,
      })

      return (
        <SocialInsightCard noPadding>
          <Insight insight={ zeroStateInsight } noCard />
        </SocialInsightCard>
      )
    }

    return result
  }, [categories, placement])

  return (
    <div className={ styles.socialInsightGroupsList }>
      { children }
    </div>
  )
}
